import {
    GETPROVIDERTYPE_SUCCESS,
    GETPROVIDERTYPE_FAILED,
    RESET_GETPROVIDERTYPE,
    LOADING_GETPROVIDERTYPE,
    NETWORK_ERROR_GETPROVIDERTYPE
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETPROVIDERTYPE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GETPROVIDERTYPE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GETPROVIDERTYPE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GETPROVIDERTYPE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GETPROVIDERTYPE:
            return (state = initialState);
        default:
            return state;
    }
};